import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { CharsGroupingService } from '../../../common/charsgrouping.service';
import { ApiUrl } from '../../../common/apiUrls';
import { MainAppComponent } from '../../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { LubricantTypeModel } from '../../../common/viewModels/GlobalRegistry/CharacteristicsModel';

declare var $: any;
@Component({
    selector: 'addlubricantchar',
    templateUrl: './addlubricantchar.component.html'
    // styleUrls: ['./spidchars.component.scss']
})


export class AddLubricantCharComponent implements OnInit {

    mainComponent: any;
    lstLubricantChars: any[];
    lstLubricantCharsTemp: any[];
    lubricantTypeId: number;
    lubricantType: LubricantTypeModel = new LubricantTypeModel();
    isCompressed: boolean = false;
    
    constructor(public _router: Router, 
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent,
        private _toastrService: ToastrService,private _charsGrpSrvc: CharsGroupingService
    ) {
        this.mainComponent = _mApp;
        this._mApp.ShowLoader();
    }

    ngOnInit() {
        this._mApp.ShowLoader();
        this.lubricantTypeId = this._route.snapshot.params['id'];
        this.GetListOfLubricantChars(this.lubricantTypeId);
    }

    GetListOfLubricantChars(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfLubricantChars + id)
            .subscribe(
            data => {
                if (data.json().Result != null){
                    this.lstLubricantChars = data.json().Result;
                    this.lstLubricantCharsTemp = data.json().Result;
                }
                this._mApp.HideLoader();
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result);
            }
            )
    }

    OnSubmit() {
        let values=[];
        for (let item of this.lstLubricantCharsTemp) {
            if (item.SubCharcteristics != null && item.SubCharcteristics != "" && item.SubCharcteristics != undefined) {
                for (let item2 of item.SubCharcteristics) {
                    if (item2.IsChecked)
                        values.push(item2.CharacteristicId)
                }
            }
            else if (item.IsChecked) {
                values.push(item.CharacteristicId)
            }
        }
        this.lubricantType.LubricantTypeId = this.lubricantTypeId;
        this.lubricantType.lstCharIds = values;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.UpsertLubricantChars, this.lubricantType)
            .subscribe(
            data => {  
                this._mApp.HideLoader();
                this._toastrService.success(data.json().Result, '');
                this._router.navigate(['/lubricanttypes']);
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            )
    }

    collapseDivison(index, isCollapsed) {
        this.lstLubricantChars[index].Collapsed = !isCollapsed;
    }

    checkOruncheckAll(index, event) {
        this.lstLubricantChars = this._charsGrpSrvc.checkOruncheckAll(index, event, this.lstLubricantChars);
        this.lstLubricantCharsTemp = this._charsGrpSrvc.checkOruncheckAllTemp(index, event, this.lstLubricantCharsTemp, this.lstLubricantChars);

    }

    checkOrUncheckMain(mainIndex) {
        this.lstLubricantChars = this._charsGrpSrvc.checkOrUncheckMain(mainIndex, this.lstLubricantChars);
        this.lstLubricantCharsTemp = this._charsGrpSrvc.checkOrUncheckMainTemp(mainIndex, this.lstLubricantCharsTemp, this.lstLubricantChars);
    }

    compressOrExpand() {
        if (this.lstLubricantChars != null && this.lstLubricantChars != undefined)
            for (let i = 0; i < this.lstLubricantChars.length; i++) {
                this.lstLubricantChars[i].Collapsed = !this.isCompressed;
            }
            this.isCompressed=!this.isCompressed;
    }

    specialSearch(val) {
        this.lstLubricantChars = this._charsGrpSrvc.specialSearch(val, this.lstLubricantCharsTemp);
    }
}